import Box from '@mui/material/Box'
import { styled } from '@mui/material/styles'
import PublicLayoutAppBar from './components/publickLayoutAppbar'
import Footer from 'src/views/common/footer'
import { useSettings } from 'src/@core/hooks/useSettings'
import { useMediaQuery } from '@mui/material'

const PublicLayoutWrapper = styled(Box)(({ theme }) => ({}))

const PublicLayout = props => {
  const { children } = props
  const { settings, saveSettings } = useSettings()
  const hidden = useMediaQuery(theme => theme.breakpoints.down('lg'))

  return (
    <PublicLayoutWrapper >
      <PublicLayoutAppBar hidden={hidden} settings={settings} saveSettings={saveSettings}/>
      <Box
        sx={{
          overflowX: 'hidden',
          position: 'relative',
          minHeight: theme => `calc(100vh - ${theme.spacing(theme.mixins.toolbar.minHeight / 4)})`
        }}
      >
        {children}
      </Box>
      {/* <LandingPageFooter /> */}
      <Footer />

    </PublicLayoutWrapper>
  )
}
export default PublicLayout
